<div>
    <app-input-text [parentFormGroup]="parentFormGroup" [parentFormControlName]="parentFormControlName"></app-input-text>
    <div *ngIf="formControl.errors" class='danger color-error form-input-error-message' style="font-size: 0.8em;">Veuillez renseigner une adresse email valide</div>
</div>

